import '../assets/styles/game.css';
import Cards from './Cards'
import { useEffect, useState } from 'react';
import { mixedCards } from '../helpers/boardHelper';
import Popup from './Popup';
import { useLocalStorage } from '../helpers/useLocalStorage';


const cardsNumber = [2, 8, 18, 32];


export default function Memory() {

  const [cards, setCards] = useState(mixedCards(2));
  const [moves, setMoves] = useState(0);
  const [level, setLevel] = useState(0);
  const [choiceOne, setChoiceOne] = useState(null);
  const [choiceTwo, setChoiceTwo] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [popup, setPopup] = useState(false);
  const [showTopPlayers, setShowTopPlayers] = useState('');
  const [player, setPlayer] = useState('');
  const [topPlayers, setTopPlayers] = useLocalStorage('memoryGame_history', []);
  const [message, setMessage] = useState('');
  const [gameOver, setGameOver] = useState(false);



  useEffect(() => {

    topPlayers.sort((firstItem, secondItem) => firstItem.moves - secondItem.moves);
    topPlayers.splice(10, 1);
    let emptyPlayers = Array(10 - topPlayers.length).fill({ player: 'unknown', moves: 0, date: "" })
    setShowTopPlayers([...topPlayers, ...emptyPlayers]);

  }, [topPlayers])


  //check choice one and two
  function handleChoice(card) {
    choiceOne ? setChoiceTwo(card) : setChoiceOne(card);
    setMoves(prevTurn => prevTurn + 1);
  }


  // save matched cards
  useEffect(() => {
    if (choiceOne && choiceTwo) {
      setDisabled(true)
      if (choiceOne.img === choiceTwo.img) {
        setCards(prevCards => {
          return prevCards.map(card => {
            if (card.img === choiceOne.img) {
              return { ...card, matched: true }
            } else {
              return card;
            }
          })
        })
        resetTurn();
      } else {
        setTimeout(() => resetTurn(), 1000);
      }
    }

  }, [choiceOne, choiceTwo])


  function resetTurn() {
    setChoiceOne(null);
    setChoiceTwo(null);
    setDisabled(false);
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  function allCardsMatched() {
    return cards.every(card => card.matched === true);
  }

  useEffect(() => {
    if (allCardsMatched() && !gameOver) {
      if (level === 3) {
        setGameOver(true);
        setPopup(true);
      } else {
        const newLevel = level + 1;
        setTimeout(() => {
          setLevel(newLevel);
          setCards(mixedCards(cardsNumber[newLevel]))
        }, 2000)
      }
    }
  }, [allCardsMatched, gameOver, level]);


  // submit player
  function handleChange(e) {
    const newPlayer = e.target.value;
    setPlayer(newPlayer);
    setMessage();
  }

  function submitPlayer(e) {
    if (player === '') {
      setMessage('>>>Input field can not be empty!<<<')
    } else {
      setPlayer(player);
      setPopup(false);
      const newTopGame = { player: player, moves: moves, date: dateTopTen() };
      setTopPlayers([...topPlayers, newTopGame]);
      e.preventDefault();
    }
  }

  function cancel() {
    setPopup(false);
    setMessage('')
  }

  function dateTopTen() {
    let d = new Date();
    let historyLine = d.getDate() + '.' + d.getMonth() + '.' + d.getFullYear() + ' ' + d.getHours() + ':' + d.getMinutes();
    return historyLine;
  }

  function newGame() {
    setCards(mixedCards(2));
    setLevel(0);
    setMoves(0);
    setMessage('');
    setGameOver(false);
    setPlayer('');
  }


  return (
    <div className="container-memory">
      <div className="board">
        {gameOver ? <button className='start-btn' onClick={newGame}>START NEW GAME</button> : ''}
        <div className='d-flex flex-column-reverse'>
        <h2 className='turns'>MOVES: {moves}</h2>
        <h1 className='level'>LEVEL: {level + 1}</h1>
        </div>
        <Cards
          handleChoice={handleChoice}
          cards={cards}
          choiceOne={choiceOne}
          choiceTwo={choiceTwo}
          disabled={disabled}
          level={level}
        />
        <p className='popup-message'>{message}</p>
        <div className="top-players">
          <div> <div className='top-ten'>TOP 10 PLAYERS:</div>
            <table>
              <thead>
                <tr>
                  <th>Rank</th>
                  <th>Name</th>
                  <th>Moves</th>
                  <th>Date & Time</th>
                </tr>
              </thead>
              {showTopPlayers && <tbody>
                {showTopPlayers.map((game, i) => (
                  <tr key={i}>
                    <td>{`${i + 1}.`}</td>
                    <td>{game.player}</td>
                    <td>{game.moves}</td>
                    <td>{game.date}</td>
                  </tr>
                ))}
              </tbody>}
            </table>

            <Popup
              popup={popup}
              player={player}
              handleChange={handleChange}
              submitPlayer={submitPlayer}
              cancel={cancel}
            />
          </div>
        </div>
      </div>
    </div>
  );
}